// extracted by mini-css-extract-plugin
export default {"wrapper":"social-item-module--wrapper--R4q+y"};